//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../no/GeometricUtilities.js";
import "../no/Expression.js";
let d=[[[1,"AddendumFactor",0,"Expression",0],[0,"AddendumType",1,0],[0,"AssociativeAxis",1,0],[0,"Axis",1,"Axis",0],[1,"BooleanOperation",0,"GeometricUtilities.BooleanOperation",0],[1,"Clearance",0,"Expression",0],[1,"FilletRadiusFactor",0,"Expression",0],[0,"HandednessOfHelix",1,0],[1,"HelixAngle",0,"Expression",0],[1,"MatchTeethNumber",0,"Expression",0],[1,"OutModule",0,"Expression",0],[0,"ParameterType",1,0],[1,"PitchAngle",0,"Expression",0],[1,"PressureAngle",0,"Expression",0],[1,"RadialAddendum",0,"Expression",0],[1,"ShaftAngle",0,"Expression",0],[1,"TangentAddendum",0,"Expression",0],[1,"TeethNumber",0,"Expression",0],[1,"ToothBreadthFactor",0,"Expression",0],[0,"ToothHeightType",1,0],[0,"Type",1,0]],[],[]];
SPLM.Features.BevelGearBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.BevelGearBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.BevelGearBuilder.Types = Object.freeze({
    "Straight" : "Straight", "Helical" : "Helical"});

SPLM.Features.BevelGearBuilder.EnumParameterType = Object.freeze({
    "PitchAngle" : "PitchAngle", "MatchingGearParameters" : "MatchingGearParameters"});

SPLM.Features.BevelGearBuilder.EnumAddendumType = Object.freeze({
    "StandardWithoutAddendum" : "StandardWithoutAddendum", "SameAddendumModification" : "SameAddendumModification"});

SPLM.Features.BevelGearBuilder.EnumHandednessOfHelixType = Object.freeze({
    "Lefthand" : "Lefthand", "Righthand" : "Righthand"});

SPLM.Features.BevelGearBuilder.EnumToothHeightType = Object.freeze({
    "EqualClearance" : "EqualClearance", "NoneEqualClearance" : "NoneEqualClearance"});

export default SPLM;